const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  startTryOn: 'start-try-on',
  VMMVAvailability: 'vmmv-availability',
  VMMVAddToCart: 'vmmv-add-to-cart',
};

const FACE_SIZE_RANGE_DEFAULTS = {
  narrow: { key: 'narrow', min: 111, max: 128 },
  average: { key: 'average', min: 123, max: 138 },
  wide: { key: 'wide', min: 133, max: 150 },
};

if (typeof window !== 'undefined') {
  window['FACE_SIZE_RANGE'] = window['FACE_SIZE_RANGE'] || FACE_SIZE_RANGE_DEFAULTS;
}
